/** Internal helper imports here ... */

/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const cookiePolicy = (() => {

  const DOM = {};

  const cacheDOM = () => {
    DOM.cookieDisclaimer = document.getElementById('js-cookie-disclaimer');
    DOM.accept = document.getElementById('accept-and-continue');
  };

  const checkCookies = () => {
    if (!localStorage.getItem('cookieDisclaimer')) {
      DOM.cookieDisclaimer.classList.add('is-active');
    }
  };

  const eventListeners = () => {
    DOM.accept.addEventListener('click', function () {
      localStorage.setItem('cookieDisclaimer', true);
      DOM.cookieDisclaimer.classList.remove('is-active');
    })
  };

  function init() {
    cacheDOM();
    checkCookies();
    eventListeners();
  }

  return {
    init
  };
})();

export default cookiePolicy;
